import React, { Component } from 'react';
import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import Checkbox from '../../Components/Checkbox';

export default class NewCity extends Component {
  render() {
    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Create City</h1>
            </div>
          </div>
          <hr/>
          <form action="/cities" className="addCityForm">
            <div className="form-field">
              <h5 className="label">City</h5>
              <input type="text" placeholder="Cairo"/>
            </div>
            <div className="form-field">
              <h5 className="label">City Code</h5>
              <input type="text" placeholder="CAI"/>
            </div>
            <div className="form-field">
              <h5 className="label">Stations</h5>
              <Checkbox text={'Abdel Monam Ryad'}/>
              <Checkbox text={'Naser City'}/>
              <Checkbox text={'Royssat'}/>
              <Checkbox text={'Almaza'}/>
              <Checkbox text={'Heliopolis'}/>
              <Checkbox text={'Heliopolis'} disapled/>
            </div>
            <hr/>
            <p>After adding your route, our operation team is going to review it. Once its approved we are going to generate <strong>456</strong> trips to your schedule table.</p>
            <Btn className="btn submit">Create City</Btn>
          </form>
          
        </div>
      </div>
    );
  }
}
